import React from "react";
import LendyIcon from "../../components/lendy/LendyIcon";

/** The top of Instructions, Memory and the intro: back to where it opened from, and the screen's name centered. */
const ProfileSubHeader = ({ title, backLabel = "Back to identity", onBack }) => (
  <div className="lendy-profile-sub">
    <button
      type="button"
      className="lendy-float-button"
      aria-label={backLabel}
      title="Back"
      onClick={onBack}
    >
      <LendyIcon name="left" />
    </button>
    <h2>{title}</h2>
    <span aria-hidden="true" />
  </div>
);

export default ProfileSubHeader;
